import { Fragment } from "react";
import Lottie from "lottie-react";
import PublicHeader from "../../../components/layouts/PublicHeader";
import { Link, ScrollRestoration, useSearchParams } from "react-router-dom";
import { getLanguageContent } from "../../../utils/language/languageSelector";
import { SERVICES_SCHEMA } from "../../../utils/schemas/language/pages/servicesSchema";
import { renderNavItem } from "../utils/contentNavBar";

function ServicesV2({ langKey }) {
  const [searchParams] = useSearchParams();
  const content = getLanguageContent(SERVICES_SCHEMA, langKey);

  const validFilters = content.page_nav.map((item) => item.value);
  const rawFilter = searchParams.get("filter");

  // If the filter exists but isn't valid, default to "all"
  const filter = validFilters.includes(rawFilter) ? rawFilter : "all";
  const path = "/services";

  const filteredOfferings =
    filter === "all"
      ? content.offerings
      : content.offerings.filter((item) => item.category === filter);

  const renderOffering = (item) => (
    <div key={item.id} className="offerings-content-item">
      <div className="offerings-content-item-intro">
        <div className="item-intro-lottie">
          <Lottie
            path={`${process.env.PUBLIC_URL}/lottie/${item.lottie}`}
            loop
            autoplay
          />
        </div>

        <div className="item-intro-title">
          <h3>{item.title}</h3>
          <Link to={item.introLink}>
            {item.cta}
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/arrow_right_alt.svg`}
              alt=""
            />
          </Link>
        </div>
      </div>

      <div className="offerings-content-item-desc">
        {item.blocks.map((block, index) => (
          <div className="group-content" key={index}>
            <h4>{block.heading}</h4>
            {block.paragraphs?.map((paragraph, paragraphIndex) => (
              <p key={paragraphIndex}>{paragraph}</p>
            ))}
            {block.items && (
              <div className="list-container">
                {block.items.map((text, itemIndex) => (
                  <div key={itemIndex} className="list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_gray.svg`}
                      alt=""
                      className="list-item-icon"
                    />
                    <span className="list-item-span">{text}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        <div className="cta-group">
          {item.ctas.map((cta, i) => (
            <Link key={i} to={cta.to} className={`cta-button ${cta.type}`}>
              {cta.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      <ScrollRestoration />
      <PublicHeader
        title={content.title}
        description={content.sub_title}
        ctas={content.hero_ctas}
      />

      <div id="container">
        <div className="offerings-container">
          <section className="offerings-nav">
            {content.page_nav.map((navItem) =>
              renderNavItem(
                path,
                filter,
                navItem.value,
                navItem.label,
                navItem.darkIcon,
                navItem.whiteIcon,
                navItem.icon_alt,
              ),
            )}
          </section>
          <section className="offerings-content">
            {filteredOfferings.map(renderOffering)}
          </section>
        </div>
      </div>
    </Fragment>
  );
}

export default ServicesV2;
